<template>
  <div class="project-device-param-settings">
    <el-form ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="活体检测" prop="liveDetection">
        <el-radio-group v-model="form.liveDetection">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="识别阈值" prop="recognitionThreshold">
        <el-slider v-model="form.recognitionThreshold" :max="1" :step="0.1"></el-slider>
      </el-form-item>
      <el-form-item label="识别距离" prop="recognitionDistance">
        <el-slider v-model="form.recognitionDistance" :max="1" :min="0.5" :step="0.1"></el-slider>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';

  export default {
    name: 'ProjectDeviceParamSettings',
    props: {
      deviceId: {
        type: Number,
        default: null
      }
    },
    watch: {
      deviceId: {
        handler(newVal, oldVal) {
          this.initDatas();
        },
        immediate: true
      }
    },
    data() {
      return {
        id: this.$route.params.id,
        form: {
          liveDetection: 1,
          recognitionThreshold: 0,
          recognitionDistance: 0
        },
        rules: {
          liveDetection: [
            {
              required: true, message: ''
            }
          ],
          recognitionThreshold: [
            {
              required: true, message: ''
            }
          ],
          recognitionDistance: [
            {
              required: true, message: ''
            }
          ],
        },
      }
    },
    methods: {
      initDatas() {
        ProjectService.deviceInfo(this.id, this.deviceId).then(res => {
          this.form.liveDetection = res.data.device_attr_data.device_aio_attr_face_living_is_on;
          this.form.recognitionThreshold = res.data.device_attr_data.device_aio_attr_face_match;
          this.form.recognitionDistance =  res.data.device_attr_data.device_aio_attr_distance;
        }).catch(() => {});
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            ProjectService.editAio(
              this.id,
              this.deviceId,
              this.form.liveDetection,
              this.form.recognitionThreshold,
              this.form.recognitionDistance
            ).then(() => {
              this.$message.success('编辑成功');
              this.$emit('cancel');
              this.$emit('submit');
            }).catch(() => {})
          }
        });
      },
      cancel() {
        this.$emit('cancel');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>